import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _mergeProps({
    class: "bar"
  }, _ctx.$attrs), [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.numberOfSegments, segment => {
    return _openBlock(), _createElementBlock("div", {
      style: _normalizeStyle({
        ...$options.segmentWidth,
        height: '100%',
        backgroundColor: `${$props.color}`
      }),
      class: "bar-segment"
    }, null, 4);
  }), 256))], 16);
}